import { render } from "./relojtiempo_ingles.vue?vue&type=template&id=87dcb0c4&scoped=true"
import script from "./relojtiempo_ingles.vue?vue&type=script&lang=js"
export * from "./relojtiempo_ingles.vue?vue&type=script&lang=js"

import "./relojtiempo_ingles.vue?vue&type=style&index=0&id=87dcb0c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dcb0c4"]])

export default __exports__